import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MatchedTransactionsSection = ({ matches, onUnmatch, onViewDetails }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-md flex items-center justify-center">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-base md:text-lg">Matched Transactions</h3>
            <p className="caption text-muted-foreground">
              {matches?.length} confirmed matches
            </p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 space-y-3 max-h-96 overflow-y-auto">
        {matches?.map((match) => (
          <div
            key={match?.id}
            className="p-4 rounded-lg border border-success/20 bg-success/5 transition-smooth hover:shadow-md"
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Link" size={16} color="var(--color-success)" />
                  <span className="caption font-medium text-success">
                    Match #{match?.id}
                  </span>
                </div>
                <p className="font-body text-sm md:text-base text-foreground line-clamp-2">
                  {match?.description}
                </p>
                <p className="caption text-muted-foreground mt-1">
                  {match?.date} • {match?.matchType}
                </p>
              </div>
              <span className="data-text text-lg md:text-xl font-semibold text-success whitespace-nowrap">
                ${match?.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>

            <div className="flex items-center justify-between pt-3 border-t border-success/10">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1.5">
                  <Icon name="Building2" size={14} color="var(--color-muted-foreground)" />
                  <span className="caption text-muted-foreground">
                    {match?.bankTransactionCount} bank
                  </span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Icon name="BookOpen" size={14} color="var(--color-muted-foreground)" />
                  <span className="caption text-muted-foreground">
                    {match?.ledgerEntryCount} ledger
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onViewDetails(match?.id)}
                  iconName="Eye"
                  iconPosition="left"
                >
                  Details
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onUnmatch(match?.id)}
                  iconName="Unlink"
                  iconPosition="left"
                >
                  Unmatch
                </Button>
              </div>
            </div>
          </div>
        ))}

        {matches?.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle2" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="font-body text-muted-foreground">No matched transactions yet</p>
            <p className="caption text-muted-foreground mt-2">
              Start matching transactions to see them here
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchedTransactionsSection;